/**
 * BuoyButton - Reusable Buoy Selection Button Component
 * 
 * SOLID Principle: Single Responsibility Principle (SRP)
 * Purpose: Renders a button for selecting/deselecting a specific buoy.
 * 
 * Responsibilities:
 * - Render button with appropriate styling based on selection state
 * - Handle click events for buoy selection toggle
 * - Provide accessible button interface
 */

import React from 'react';
import styles from '../SensorDashboard.module.css';

export const BuoyButton = React.memo(({ id, isSelected, onClick, children }) => (
  <button
    onClick={onClick}
    className={`${styles.btn} ${isSelected ? styles.btnActive : ''}`}
  >
    {children}
  </button>
));

BuoyButton.displayName = 'BuoyButton';

export default BuoyButton;